import constants from 'constants/index'

const chipStatusBgColor = (status) => {
  return (
    (status && constants.audits.CHIP_STATUS_BACKGROUND_COLOR[status]) ||
    undefined
  )
}

export default chipStatusBgColor
